import React, { useState } from "react";
import logo from "./assets/logo.png";
import { apiFetch } from "./api";
import { GoogleLogin } from "@react-oauth/google";

function Login({ setPage }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // MukBi V1.6 — Session takeover confirmation
  const [takeoverToken, setTakeoverToken] = useState(null);
  const [isSwitchingSession, setIsSwitchingSession] = useState(false);

  // Shared successful login handler
  const completeLogin = (data) => {
    if (!data.token || !data.userId) {
      throw new Error("Invalid login response");
    }

    localStorage.setItem("token", data.token);
    localStorage.setItem("userId", data.userId);
    localStorage.setItem("userEmail", data.email);
    localStorage.setItem("userName", data.name);

    setTakeoverToken(null);
    setPage("dashboard");
  };

  const container = {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f6fa"
  };

  const card = {
    background: "white",
    padding: 30,
    borderRadius: 10,
    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
    width: 300,
    textAlign: "center"
  };
  const input = {
    width: "100%",
    padding: 10,
    margin: "10px 0",
    borderRadius: 6,
    border: "1px solid #ccc"
  };
  const button = {
    width: "100%",
    padding: 10,
    background: "#2c3e50",
    color: "white",
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    marginTop: 10
  };
  const link = {
    color: "#3498db",
    cursor: "pointer",
    fontWeight: "500"
  };

  const handleLogin = async () => {
    // Clear any confirmation from a previous login attempt.
    setTakeoverToken(null);

    try {
      const res = await apiFetch("/login", {
        method: "POST",
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();

      // Another device is already logged in.
      if (
        res.status === 409 &&
        data.code === "ACTIVE_SESSION_EXISTS" &&
        data.takeoverToken
      ) {
        setTakeoverToken(data.takeoverToken);
        return;
      }

      // Normal successful login.
      if (res.ok && data.token && data.userId) {
        completeLogin(data);
        return;
      }

      alert(data.error || "Login failed");

    } catch (err) {
      console.error("Login error:", err);
      alert("Unable to login. Please try again.");
    }
  };
  const handleSessionTakeover = async () => {
    if (!takeoverToken || isSwitchingSession) return;

    setIsSwitchingSession(true);

    try {
      const res = await apiFetch("/session/takeover", {
        method: "POST",
        body: JSON.stringify({ takeoverToken })
      });

      const data = await res.json();

      if (res.ok && data.token && data.userId) {
        completeLogin(data);
        return;
      }

      setTakeoverToken(null);
      alert(data.error || "Unable to switch session. Please log in again.");

    } catch (err) {
      console.error("Session takeover error:", err);
      alert("Unable to switch session. Please try again.");
    } finally {
      setIsSwitchingSession(false);
    }
  };

  return (

  <div style={container}>

    <div style={card}>
    <h1 style={{ marginBottom: 10 }}>Mukbi CRM</h1>
      <img
        src={logo}
        alt="Mukbi CRM"
        style={{ width: 120, marginBottom: 10 }}
      />

      <h2>Login</h2>
      {takeoverToken && (
        <div
          role="alertdialog"
          aria-labelledby="session-dialog-title"
          aria-describedby="session-dialog-description"
          style={{
            background: "#fff8e6",
            border: "1px solid #e6bd68",
            borderRadius: 8,
            padding: 15,
            marginBottom: 15,
            textAlign: "left"
          }}
        >
          <h3 id="session-dialog-title" style={{ marginTop: 0 }}>
            Another Session Is Active
          </h3>

          <p id="session-dialog-description" style={{ fontSize: 14 }}>
            Your MukBi account is already logged in on another device.
            Would you like to end that session and continue here?
          </p>

          <button
            type="button"
            disabled={isSwitchingSession}
            onClick={() => setTakeoverToken(null)}
            style={{
              ...button,
              background: "#6c757d"
            }}
          >
            Keep Existing Session
          </button>

          <button
            type="button"
            disabled={isSwitchingSession}
            onClick={handleSessionTakeover}
            style={button}
          >
            {isSwitchingSession
              ? "Switching Session..."
              : "End Other Session & Continue"}
          </button>
        </div>
      )}

      <input
        placeholder="Email"
        value={email}
        onChange={e => setEmail(e.target.value)}
        style={input}
      /><br /><br />

      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        style={input}
      /><br /><br />


      <div style={{ textAlign: "right", marginTop: 0, marginBottom: 12 }}>
        <span
          onClick={() => setPage("forgot-password")}
          style={{
            ...link,
            fontSize: 13
          }}
        >
          Forgot Password?
        </span>
      </div>


      <button onClick={handleLogin} style={button}
        onMouseOver={(e) => {
          e.target.style.background = "#34495e";
          e.target.style.transform = "scale(1.02)";
        }}
        onMouseOut={(e) => {
          e.target.style.background = "#2c3e50";
          e.target.style.transform = "scale(1)";
        }}>
        Login
      </button>
      <div style={{ marginTop: 15, marginBottom: 15 }}>
      <GoogleLogin
        onSuccess={async (credentialResponse) => {
          setTakeoverToken(null);
          try {
            const res = await apiFetch("/google-login", {
              method: "POST",
              body: JSON.stringify({
                credential: credentialResponse.credential
              })
            });

            const data = await res.json();

            if (
              res.status === 409 &&
              data.code === "ACTIVE_SESSION_EXISTS" &&
              data.takeoverToken
            ) {
              setTakeoverToken(data.takeoverToken);
              return;
            }

            if (res.ok && data.token && data.userId) {
              completeLogin(data);
            } else {
              alert(data.error || "Google Login Failed");
            }

          } catch (err) {
            console.error(err);
            alert("Google Login Failed");
          }
        }}
        onError={() => {
          alert("Google Login Failed");
        }}
      />
      </div>
      <p>
        New user?{" "}
        <span
          onClick={() => setPage("signup")}
          style={link}   // 👈 APPLY HERE
        >
          Signup
        </span>
      </p>
    </div>
  </div>

  );
}

export default Login;